import React from "react";
import { motion } from "framer-motion";
import { SmileMark } from "../brand/Brand";
import { fadeUp, viewportOnce } from "../../lib/motion";

const promesses = [
  { title: "Toujours proche", line: "À deux pas de chez vous." },
  { title: "Toujours frais", line: "Des produits frais chaque jour." },
  { title: "Toujours pratique", line: "Tout ce dont vous avez besoin." },
  { title: "Toujours économique", line: "Des prix justes, chaque jour." },
  { title: "Toujours avec le sourire", line: "Un service chaleureux." },
];

export default function NosPromesses() {
  return (
    <section
      data-testid="nos-promesses-section"
      className="relative bg-diallo-red text-white py-20 md:py-28 overflow-hidden grain"
    >
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="mb-4 flex items-center gap-3 font-display text-sm font-semibold tracking-widest uppercase text-white/70"
        >
          <span>05</span>
          <span className="h-2 w-2 rounded-full bg-white" />
          <span>Nos promesses</span>
        </motion.div>
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          className="font-display font-extrabold tracking-tight text-4xl md:text-5xl lg:text-6xl max-w-[18ch]"
        >
          Cinq promesses. Une seule marque.
        </motion.h2>
      </div>

      {/* Editorial marquee */}
      <div className="marquee-track mt-14 relative flex overflow-hidden select-none">
        <div className="animate-marquee flex shrink-0 items-center gap-10 pr-10">
          {[...promesses, ...promesses].map((p, i) => (
            <div key={i} className="flex items-center gap-10">
              <span className="font-display font-extrabold text-2xl md:text-4xl whitespace-nowrap">
                {p.title}
              </span>
              <SmileMark color="#FFFFFF" size={40} strokeWidth={7} className="shrink-0" />
            </div>
          ))}
        </div>
      </div>

      {/* Promise cards */}
      <div className="mx-auto max-w-7xl px-5 md:px-8 mt-14">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.08 } } }}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4"
        >
          {promesses.map((p) => (
            <motion.div
              key={p.title}
              variants={fadeUp}
              data-testid={`promesse-${p.title}`}
              className="rounded-2xl bg-white/10 backdrop-blur-sm p-6 transition-colors duration-300 hover:bg-white/15"
            >
              <SmileMark color="#FFFFFF" size={34} strokeWidth={7} />
              <h3 className="mt-4 font-display font-bold text-lg">{p.title}</h3>
              <p className="mt-1 text-white/80 text-sm">{p.line}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
